// components/OperationalDetails.jsx
import React from "react";
import Table from "rc-app/components/Table";

const OperationalDetails = ({ client, className = "" }: any) => {
  const columns = [
    "Client Incorporation Year",
    "Client Incorporation Type",
    "Client Subsdiary Names ",
    "Client Acreage Completed",
    "Client Sqft Built",
  ];

  const renderRow = (client: any, index: number) => (
    <tr
      key={index}
      className="hover:bg-[#35495E] transition-colors text-base text-[#F4F5F7]"
    >
      <td className="px-4 py-3  font-semibold">
        <div className="flex items-center gap-2">
          {client?.incorporation_year || "Not Available"}
        </div>
      </td>
      <td className="px-4 py-3 font-normal">{client?.incorporation_type || "Not Available"}</td>
      <td className="px-4 py-3 font-medium">{client?.agency_subsidiary_names || "Not Available"}</td>
      <td className="px-4 py-3 font-semibold">
        {client?.client_acreage_acquired?.value || "Not Available"}
      </td>
      <td className="px-4 py-3 font-semibold">{client?.client_sqft_built?.value || "Not Available" }</td>
    </tr>
  );

  console.log("OperationalDetails", client?.client_sqft_built?.value );

  return (
    <Table
      title="Agents"
      columns={columns}
      data={client}
      renderRow={renderRow}
      emptyMessage="No agents available"
      className={className}
      sortableColumns={[0, 1, 2, 3, 4]}
      columnKeys={[
        "incorporation_year",
        "incorporation_type",
        "agency_subsidiary_names",
        "client_acreage_acquired.value",
        "client_sqft_built.value",
      ]}
    />
  );
};

export default OperationalDetails;
